var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "ic-cancel_svg__b",
    width: "102.3%",
    height: "102%",
    x: "-1.2%",
    y: "-.9%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 1,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0725486866 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0.290196078 0 0 0 0 0.290196078 0 0 0 0 0.290196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    "in": "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter3",
    result: "shadowBlurOuter3",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter3",
    result: "shadowMatrixOuter3",
    values: "0 0 0 0 0.290196078 0 0 0 0 0.290196078 0 0 0 0 0.290196078 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ic-cancel_svg__d",
    width: "102.3%",
    height: "111.8%",
    x: "-1.2%",
    y: "-6.6%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 0.5,
    result: "shadowSpreadOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1,
    "in": "shadowSpreadOuter1",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    values: "0 0 0 0 0.290196078 0 0 0 0 0.290196078 0 0 0 0 0.290196078 0 0 0 0.2 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "ic-cancel_svg__a",
    d: "M5 0h681a5 5 0 015 5v798a5 5 0 01-5 5H5a5 5 0 01-5-5V5a5 5 0 015-5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic-cancel_svg__e",
    d: "M-2-2h694v136H-2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ic-cancel_svg__f",
    x1: "89.052%",
    x2: "2.642%",
    y1: "0%",
    y2: "95.439%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4AFFCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#7DBFCC"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    d: "M-171-144h1280V956H-171z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-30 -20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic-cancel_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic-cancel_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ic-cancel_svg__b)",
    xlinkHref: "#ic-cancel_svg__a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#ic-cancel_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ic-cancel_svg__c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ic-cancel_svg__d)",
    xlinkHref: "#ic-cancel_svg__e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#ic-cancel_svg__e"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 53,
    r: 2,
    fill: "url(#ic-cancel_svg__f)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 8,
    r: 1,
    fill: "url(#ic-cancel_svg__f)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 37.5,
    r: 1.5,
    fill: "url(#ic-cancel_svg__f)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 8.5,
    r: 1.5,
    fill: "url(#ic-cancel_svg__f)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3B385E",
    strokeWidth: 2,
    d: "M44.211 22.387a1 1 0 011 1v4.704h0c-2.084 0-3.774 1.703-3.774 3.803 0 2.1 1.69 3.802 3.774 3.802V40.4a1 1 0 01-1 1H12.246a1 1 0 01-1-1v-4.704h0c2.084 0 3.774-1.702 3.774-3.802s-1.69-3.803-3.774-3.803v-4.704a1 1 0 011-1h31.965z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B385E",
    d: "M44.129 22.357l1.85 4.5-1.85 1.668-2.475 1.887v2.706l1.184 1.626 1.291.908.84 1.032v3.828l-4.231 1.137H16.462z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#3B385E",
    d: "M7 46.189L49.02 16"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    d: "M7 48.328l42.02-30.189"
  }))))));
}
export default SvgIcCancel;